import { render, staticRenderFns } from "./FootprintTracker.vue?vue&type=template&id=73fd5833&lang=pug"
import script from "./FootprintTracker.vue?vue&type=script&lang=js"
export * from "./FootprintTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports